<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasBuyer="true"
      :hasFood="true"
      :hasFoodKind="true"
      :hasFoodStatusType="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
    };
  },
  computed: {
    columns() {
      return [
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "TradeNumber" },
        { name: "TradeDate" },
        { name: "InvoiceNumber" },
        { name: "TradeType" },
        { name: "TradeMemo" },
        { name: "SupplierNumber" },
        { name: "SupplierName" },
        { name: "Qty" },
        { name: "Price" },
        { name: "Total" },
        { name: "Unit" },
        { name: "Memo" },
      ];
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getFoodPurchase(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getFoodPurchase(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printFoodPurchase(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getFoodPurchase(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
